<!-- 客户反馈 -->
<template>
  <div class="client_form workOrderTem">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px" class="demo-ruleForm">
      <el-form-item v-if="!form.id" :label="$t('workOrder.device_sn')" prop="productSn">
        <el-input v-model="form.productSn" />
      </el-form-item>

      <el-form-item :label="$t('workOrder.client')" prop="client">
        <el-input v-model="form.client" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.contact_details')" prop="contactDetails">
        <el-input v-model="form.contactDetails" />
      </el-form-item>

      <el-form-item :label="$t('workOrder.FaultDescription')" prop="descriptionKey">
        <el-select v-model="form.descriptionKey" class="searchBox" :placeholder="$t('AllDevices.Status')" filterable @change="changeDescKey">
          <el-option v-for="(item,index) in descriOption" :key="index" :label="item.text" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.descriptionKey==3" :label="$t('workOrder.SpecificDescription')" prop="description">
        <el-input v-model="form.description" type="textarea" :placeholder="$t('workOrder.DescribeDetail')" maxlength="100" />
      </el-form-item>
      <!-- <el-form-item :label="$t('company.backgroundImage')"> -->
      <el-form-item :label="$t('sim.uploadFiles')">
        <el-upload class="upload-demo popUpload" action="" :auto-upload="false" :file-list="fileList" :on-change="handleChange" list-type="picture">
          <el-button size="small" type="primary">{{ $t('company.uploadImg') }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ $t('workOrder.uploadPicVideo') }}</div>
        </el-upload>
        <div v-if="form.uploadUrl" class="imgBox">
          <el-image v-if="form.uploadType=='image'" :src="form.uploadUrl" :alt="$t('company.backgroundImage')" class="img" style="height: 70px" :preview-src-list="[form.uploadUrl]" />
          <i class="el-icon-close" @click="closeImg" />
          <video v-if="form.uploadType=='video'" controls="controls" width="200" height="70">
            <source :src="form.uploadUrl" type="video/mp4">
          </video>
        </div>
      </el-form-item>

      <el-form-item class="btnWarp">
        <el-button type="primary" :disabled="subDisabled" @click="submitForm('ruleForm')">{{ isEdit?$t('workOrder.Revise'): $t('workOrder.save') }}</el-button>
        <el-button @click="clickCancel('quxiao')">{{ $t('workOrder.cancel') }}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { getChargerData, uploadImg, uploadImgAndCompression } from '@/api/workOrder'
import { isObjectValueEqual } from '@/utils'
export default {
  components: {},
  props: ['raw', 'current'],
  data() {
    return {
      attrArr: ['client', 'contactDetails', 'descriptionKey', 'description', 'uploadUrl', 'uploadType'], // 需要对比的属性
      initObj: {}, // 判断是否有改变项--初始化时的值
      newObj: {}, // 判断是否有改变项--最新的值
      subDisabled: false,
      form: {
        client: '',
        contactDetails: '',
        problemType: '',
        productSn: '',
        productType: 1,
        remark: '',
        status: 1,
        step1: '',
        description: '',
        descriptionKey: null,
        uploadUrl: null,
        uploadType: null
      },
      descriOption: [],
      fileList: [],
      uploadUrl: null, // 上传文件的url
      uploadType: null, // 上传文件的类型
      isEdit: false // 修改
    }
  },
  computed: {
    rules() {
      return {
        productSn: [
          { required: !this.form.id, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' },
          { validator: this.validateSn, trigger: 'blur' }
        ],
        client: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        contactDetails: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
          // { validator: this.validateContact, trigger: ['blur', 'change'] }
        ],
        description: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
    raw: {
      deep: true,
      handler(obj) {
        this.initForm(obj)
      }
    }
    // popShow: {
    //   deep: true,
    //   handler() {
    //     if (this.popShow) this.initForm(this.raw)
    //   }
    // }
  },
  mounted() {
    this.initForm(this.raw)
  },
  methods: {
    uploadErrorFn(str) { // 上传文件错误处理
      this.$message({
        type: 'error',
        message: str
      })
      this.fileList = this.fileList.length ? [this.fileList[0]] : []
    },
    handleChange(file) { // 上传弹窗
      if (file.raw.type.indexOf('video') == -1 && file.raw.type.indexOf('image') == -1) { // 格式不对，请上传图片！
        this.uploadErrorFn(this.$t('workOrder.formatWrong'))
        return
      } else if (file.size > 20 * 1024 * 1024) { // 图片大小不能超过5M，请重试！
        this.uploadErrorFn(this.$t('workOrder.overSize').replace('5M', '20M'))
        return
      } else if (file.name.length > 100) { // 图片名称长度不能超过100，请重试！
        this.uploadErrorFn(this.$t('workOrder.imgNameLen'))
        return
      }
      file.childDir = 'productProblemTracking'
      var request = uploadImg
      if (file.raw.size > 1024 * 1024 * 5)request = uploadImgAndCompression // 大于5M压缩
      request(file).then(res => {
        if (res.resultCode == 1001) {
          this.fileList = [file]
          this.uploadUrl = this.form.uploadUrl = res.resultModel
          this.uploadType = this.form.uploadType = file.raw.type.indexOf('image') > -1 ? 'image' : 'video'
        } else {
          this.$message({
            type: 'error',
            message: this.$t('workOrder.ImgUploadFailed') // 文件上传失败，请重试！
          })
          this.fileList = this.fileList.length ? [this.fileList[0]] : []
        }
      })
    },
    closeImg() {
      this.uploadType = this.form.uploadType = this.uploadUrl = this.form.uploadUrl = null
      this.uploadList = []
    },
    changeDescKey() { // 改变问题
      this.descriOption.forEach(v => {
        if (v.value == this.form.descriptionKey) this.form.description = this.form.descriptionKey != 3 ? v.text : ''
      })
    },
    getDescriOption() { // 获取故障下拉框
      this.descriOption = []
      var configList = this.$storage.get('configList') || []
      console.log('configList', configList)
      configList.forEach((v, i) => {
        if (v.key == 'faultDescription') {
          var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
          arr.forEach((m, i) => {
            this.descriOption.push({
              value: i,
              text: m
            })
          })
        }
      })
      if (!configList.length) {
        setTimeout(() => {
          this.getDescriOption()
        }, 500)
      }
    },
    validateSn(rule, value, callback) { // 校验sn是否正确
      getChargerData(this.form.productSn).then(res => {
        console.log('充电器信息：', res)
        if (res.resultCode == 1001 && res.resultModel) {
          callback()
        } else {
          callback(new Error(this.$t('BondOrUpdateDevice.SNNotFound')))
          // this.$message.error('找不到设备，请检查输入的SN是否正确');
        }
      })
    },
    validateContact(rule, value, callback) { // 校验联系方式
      var isMob = /^([0-9]{3,4}-)?[0-9]{7,8}$/ // 电话号码
    	var isPhone = /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{9}|17[02356789][0-9]{8}||18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/ // 手机
    	var regEmail = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/ // 邮箱
      if (isMob.test(value) || isPhone.test(value) || regEmail.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的联系方式！'))
      }
    },
    initForm(raw) { // 初始化
      console.log('客户反馈表单：raw', raw)
      this.isEdit = false
      this.getDescriOption()// 获取故障下拉框
      if (!raw) {
        this.initObj = {
          client: '',
          contactDetails: '',
          description: '',
          descriptionKey: null,
          uploadType: null,
          uploadUrl: null
        }
        this.resetForm('ruleForm')
        return
      }
      for (const key in raw) {
        if (Object.hasOwnProperty.call(raw, key)) {
          const element = raw[key]
          this.form[key] = element
        }
      }
      if (raw.step1) {
        var step = JSON.parse(raw.step1)
        console.log('客户反馈表单initForm:step', step)
        this.form.description = step.description
        this.form.descriptionKey = (step.descriptionKey || step.descriptionKey == 0) ? step.descriptionKey : 3
        this.form.uploadUrl = step.uploadUrl
        this.form.uploadType = step.fileType
        this.isEdit = true
      }
      if (raw) this.initObj = this.getObjFn(this.form)
      console.log('initForm:this.form', this.form)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.subDisabled = true
          setTimeout(() => {
            this.subDisabled = false
          }, 2000)

          this.form.step1 = JSON.stringify({
            description: this.form.description,
            descriptionKey: this.form.descriptionKey,
            uploadUrl: this.uploadUrl,
            fileType: this.uploadType
          })
          console.log(this.form)
          this.$emit('save', this.form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    clickCancel(val) {
      console.log('client:clickCancel')
      this.newObj = this.getObjFn(this.form)
      this.$emit('back', this.initObj, this.newObj, val)
    },
    getObjFn(obj) {
      var newObj = {}
      this.attrArr.forEach(v => {
        newObj[v] = obj[v]
      })
      return newObj
    }

  }
}
</script>

<style lang='scss' scoped>
.client_form {
  width: 700px;
  margin: 20px auto;
}
.workOrderTem .imgBox{
  width: 50%
}

</style>
